<template>
  <!-- Fixed bottom-right, compact size -->
  <div v-if="store.hasActiveUploads" class="fixed bottom-4 right-4 z-50 w-96">
    <div class="bg-white rounded-lg shadow-2xl border border-gray-200">
      <!-- Header -->
      <div
        class="flex items-center justify-between px-4 py-2 border-b bg-gray-50 rounded-t-lg"
      >
        <h4 class="font-semibold text-xs text-gray-700">
          Uploads ({{ store.uploadCount }})
        </h4>
        <div class="flex items-center gap-3">
          <button
            type="button"
            @click="toggleCollapsed"
            class="text-gray-500 hover:text-gray-700 transition-colors"
            :aria-label="isCollapsed ? 'Expand uploads' : 'Collapse uploads'"
            :title="isCollapsed ? 'Expand' : 'Collapse'"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                v-if="isCollapsed"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 15l7-7 7 7"
              />
              <path
                v-else
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          <button
            type="button"
            @click="store.clearAll()"
            class="text-xs text-gray-500 hover:text-red-600 transition-colors font-medium"
          >
            Clear All
          </button>
        </div>
      </div>

      <!-- Upload List - Shows 1 full item (~180px), scrollable for more -->
      <div v-if="!isCollapsed" class="overflow-y-auto max-h-48">
        <BulkUploadStatusItem
          v-for="[uploadId, upload] in store.activeUploads"
          :key="uploadId"
          :upload-id="uploadId"
          :upload="upload"
        />
      </div>

      <!-- Collapsed body -->
      <div v-else class="px-4 py-3 text-xs text-gray-600">
        Uploads are running in the background.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useBulkUploadStore } from "@/stores/bulkUploadStore";
import BulkUploadStatusItem from "./BulkUploadStatusItem.vue";

const store = useBulkUploadStore();
const COLLAPSE_KEY = "slashexperts_bulk_uploads_collapsed";
const isCollapsed = ref(false);

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value;
};

onMounted(() => {
  // Store auto-loads from localStorage on initialization
  // This is just for explicit re-check on mount
  store.loadFromStorage();

  try {
    isCollapsed.value = localStorage.getItem(COLLAPSE_KEY) === "true";
  } catch {
    // ignore
  }
});

watch(isCollapsed, (val) => {
  try {
    localStorage.setItem(COLLAPSE_KEY, val ? "true" : "false");
  } catch {
    // ignore
  }
});
</script>
